import { DeviceTypeWording } from "./constants/DevicesConstants";
import { PromptTypes } from "./constants/PromoTypesConstants";

export const deviceDimensions = (deviceType, promptType, isMobile = false) => {
  if (promptType === PromptTypes.email.value) return null;
  if (promptType === PromptTypes.text.value) return null;
  if (PromptTypes.bottom_banner.value === promptType) {
    if (deviceType === DeviceTypeWording.roku_os.value) return "1200 x 200 px";
    if (deviceType === DeviceTypeWording.android_tv.value) return "1200 x 200 px";
    if (deviceType === DeviceTypeWording.tv_os.value) return "1200 x 200 px";
    if (deviceType === DeviceTypeWording.custom_defined.value) return "1000 x 100 px";
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "100% x 120 px" : "1000 x 100 px";
    if (deviceType === DeviceTypeWording.android_os.value)
      return isMobile ? "900 x 200 px" : "1300 x 300 px";
    if (deviceType === DeviceTypeWording.ios.value)
      return isMobile ? "900 x 200 px" : "1300 x 300 px";
  }
  if (promptType === PromptTypes.widget.value) {
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "100% x 120 px" : "450 x 180 px";
  }
  if (promptType === PromptTypes.interstitial.value) {
    if (deviceType === DeviceTypeWording.roku_os.value) return "1920 x 1080 or 3840 x 2160 px";
    if (deviceType === DeviceTypeWording.android_tv.value) return "1920 x 1080 or 3840 x 2160 px";
    if (deviceType === DeviceTypeWording.tv_os.value) return "1920 x 1080 px or 3840 x 2160 px";
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "337.5 x 479.5 px" : "1200 x 800 px";
    if (deviceType === DeviceTypeWording.android_os.value)
      return isMobile ? "1200 x 2400 px" : "1200 x 2400 px";
    if (deviceType === DeviceTypeWording.ios.value)
      return isMobile ? "1200 x 2400 px" : "1200 x 2400 px";
  }
  if (promptType === PromptTypes.horizontal.value) {
    if (deviceType === DeviceTypeWording.roku_os.value) return "1400 x 200 px";
    if (deviceType === DeviceTypeWording.android_tv.value) return "1400 x 200 px";
    if (deviceType === DeviceTypeWording.tv_os.value) return "1400 x 200 px";
    if (deviceType === DeviceTypeWording.custom_defined.value) return "960 x 300 px";
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "300 x 200 px" : "960 x 300 px";
    if (deviceType === DeviceTypeWording.android_os.value)
      return isMobile ? "1000 x 200 px" : "1500 x 300 px";
    if (deviceType === DeviceTypeWording.ios.value)
      return isMobile ? "1000 x 200 px" : "1500 x 300 px";
  }
  if (promptType === PromptTypes.vertical.value) {
    if (deviceType === DeviceTypeWording.roku_os.value) return "300 x 1000 px";
    if (deviceType === DeviceTypeWording.android_tv.value) return "300 x 1000 px";
    if (deviceType === DeviceTypeWording.tv_os.value) return "300 x 1000 px";
    if (deviceType === DeviceTypeWording.custom_defined.value) return "250 x 500 px";
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "200 x 300 px" : "250 x 500 px";
    if (deviceType === DeviceTypeWording.android_os.value)
      return isMobile ? "300 x 1400 px" : "300 x 1500 px";
    if (deviceType === DeviceTypeWording.ios.value)
      return isMobile ? "300 x 1400 px" : "300 x 1500 px";
  }
  if (promptType === PromptTypes.tile.value) {
    if (deviceType === DeviceTypeWording.roku_os.value) return "320 x 180 px";
    if (deviceType === DeviceTypeWording.android_tv.value) return "320 x 180 px";
    if (deviceType === DeviceTypeWording.tv_os.value) return "320 x 180 px";
    if (deviceType === DeviceTypeWording.custom_defined.value) return "250 x 500 px";
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "375 x 205 px" : "250 x 500 px";
    if (deviceType === DeviceTypeWording.android_os.value)
      return isMobile ? "320 x 180 px" : "360 x 200 px";
    if (deviceType === DeviceTypeWording.ios.value)
      return isMobile ? "320 x 180 px" : "360 x 200 px";
  }
  if (promptType === PromptTypes.retention_modal.value) {
    if (deviceType === DeviceTypeWording.roku_os.value) return "1400 x 790 px or 1920 x 1080 px";
    if (deviceType === DeviceTypeWording.android_tv.value) return "1600 x 1200 px";
    if (deviceType === DeviceTypeWording.tv_os.value) return "1600 x 1200 px";
    if (deviceType === DeviceTypeWording.web.value)
      return isMobile ? "500 x 800 px" : "1200 x 800 px, 960 x 640 px, 750 x 500 px";
    if (deviceType === DeviceTypeWording.custom_defined.value)
      return "1200 x 800 px, 960 x 640 px, 750 x 500 px";
    if (deviceType === DeviceTypeWording.android_os.value)
      return isMobile ? "1024 x 1024 px" : "1024 x 1024 px";
    if (deviceType === DeviceTypeWording.ios.value)
      return isMobile ? "1024 x 1024 px" : "1024 x 1024 px";
  }

  return null;
};
